<app-frontend-navigation [autoSelect]="true" [subNavigation]="true" [items]="navigationItems" [showMobileLabels]="true"/>

<div class="player-profile-tab-content-top0">
  <router-outlet/>
</div>

<!--<div class="player-profile-tab-content">

</div>-->
